import axios from 'axios'
import { languageCheck } from '../utils/utils'
import ResponseData from '../types/types'

const url = new URL(window.location.href)

const API_URL = `${url.origin}/api-v2`

const API_URL_LIST = `${API_URL}/list`

export async function getDistanceReport(data: {
  url: string
  payload: any
}): Promise<ResponseData> {
  try {
    const url: string = `${API_URL_LIST}/${data.url}`
    return axios.post(url, data.payload)
  } catch (error) {
    throw new Error(`Error fetching distance: ${error}`)
  }
}

export async function getListByInput(data: { url: string; payload: any }): Promise<ResponseData> {
  try {
    const form: FormData = new FormData()
    form.append('filter', data.payload.filter)
    form.append('list', data.payload.list)
    form.append('language', languageCheck().toUpperCase())
    const url: string = `${API_URL_LIST}/${data.url}`
    return axios.post(url, form)
  } catch (error) {
    throw new Error(`Error fetching list by input: ${error}`)
  }
}
